<template>
  <div class="pt-16">
    <h2 class="pt-6 pb-3">
      Bulk Upload CSV <sup><small>V2</small></sup>
    </h2>
    <v-container>
      <v-tabs v-model="uploadType" fixed-tabs background-color="primary" dark>
        <v-tab @click="reset">
          <i class="mdi mdi-upload" aria-hidden="true"></i>Upload <br />VoIP
          Services
        </v-tab>
        <v-tab @click="reset">
          <i class="mdi mdi-upload" aria-hidden="true"></i>Upload <br />Misc
          Transactions
        </v-tab>
        <v-tab @click="reset">
          <i class="mdi mdi-upload" aria-hidden="true"></i>Upload <br />New
          Mobiles
        </v-tab>
        <v-tab @click="reset">
          <i class="mdi mdi-upload" aria-hidden="true"></i>Upload <br />New
          Customers
        </v-tab>
        <v-tab @click="reset">
          <i class="mdi mdi-upload" aria-hidden="true"></i>Upload
          <br />Disconnect Services
        </v-tab>
        <v-tab @click="reset">
          <i class="mdi mdi-upload" aria-hidden="true"></i>Upload <br />NBN
          Services
        </v-tab>
        <v-tab @click="reset">
          <i class="mdi mdi-upload" aria-hidden="true"></i>Upload <br />MNF
          Agents
        </v-tab>
        <v-tab @click="reset" v-if="allFlags.SOG3252">
          <i class="mdi mdi-upload" aria-hidden="true"></i>Upload <br />Inbound
          Services
        </v-tab>
      </v-tabs>

      <v-tabs-items>
        <h3 v-text="getUploadType" class="pt-8"></h3>
        <v-card>
          <v-row align="center" no-gutters class="mt-8">
            <input type="file" hidden id="logFile" />
            <v-col cols="4">
              <v-file-input
                outlined
                dense
                clearable
                @click:clear="reset"
                label="File input"
                v-model="file"
                @change="readCSV"
                class="mt-8"
              ></v-file-input>
            </v-col>
            <v-col cols="8">
              <v-row class="uploadbtns pt-2" align="center">
                <v-col cols="3">
                  <v-btn @click="onUpload">Submit Data</v-btn>
                </v-col>
                <v-col cols="3">
                  <v-btn @click="downloadCsvExample">Example Data</v-btn>
                </v-col>
                <v-col cols="3">
                  <v-btn @click="csvExport">Results Data</v-btn>
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                    v-model="useIndiviualField"
                    v-if="uploadType == 3"
                    @change="updateUseIndiviualField"
                    label="Use individual address fields"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="excludePayment"
                    v-if="uploadType == 0 || uploadType == 2 || uploadType == 4"
                    label="Exclude from commissions payment"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-tabs-items>
    </v-container>
    <v-container>
      <v-dialog eager v-model="show" persistent max-width="50%">
        <field-settings
          ref="config"
          @updateHeader="updateHeader"
          @close="close"
        ></field-settings>
      </v-dialog>
      <v-dialog eager v-model="showPrompt" persistent max-width="50%">
        <v-card>
          <v-card-title class="text-h5">
            <span class="headline">
              <v-icon left>mdi-alert-circle-outline</v-icon>
              <span>Confirm</span>
            </span>
          </v-card-title>

          <v-card-text class="body-1">
            The file contains more than 200 lines of data, result will be sent
            to your logged in email.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="showPrompt = false"> Ok </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div class="row pb-2">
        <div class="col-3">
          <v-text-field
            v-model="search"
            label="Filter"
            hide-details
            dense
            outlined
            :disabled="file == null"
          ></v-text-field>
        </div>
        <div class="col text-right">
          <v-btn
            color="primary"
            @click="onExportCsv"
            :disabled="rowData.length == 0"
            >Export to CSV</v-btn
          >
        </div>
      </div>
      <v-card>
        <ag-grid-vue
          style="height: 500px"
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :rowData="rowData"
          :defaultColDef="defaultColDef"
          @grid-ready="onGridReady"
          :enableCellTextSelection="true"
          :ensureDomOrder="true"
        ></ag-grid-vue>
      </v-card>
    </v-container>

    <ProcessLoader ref="loader" :loaded="loaded" :uploadData="rowData.length" />
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { HTTP } from "@/http-common";
import {
  voipServicesHeaders,
  voipServicesExampleHeader,
  transactionsHeaders,
  newMobilesHeaders,
  newMobilesExampleHeaders,
  disconnectHeaders,
  nbnHeaders,
  nbnExampleHeaders,
  mnfHeaders,
  customerHeaders,
  customerExampleHeader,
  inboundHeaders,
} from "@/data/csvHeaders";
import {
  voipServicesExample,
  transactionsExample,
  newMobilesExample,
  disconnectExample,
  nbnExample,
  customerExample,
  customer2Example,
  inboundExample,
} from "@/data/csvExampleData";
import {
  VoipService,
  createVoipServiceWithHeaderName,
} from "@/models/VoipService";
import {
  Transaction,
  createTransactionWithHeaderName,
} from "@/models/Transaction";
import { Customer, createCustomer } from "@/models/Customer";
import {
  DisconnectService,
  createDisconnectServiceWithHeaderName,
} from "@/models/DisconnectService";
import parse from "csv-parse";
import ProcessLoader from "@/components/process-loader";
import FieldSettings from "@/components/field-settings";
import { mnfAgentExampleData } from "../data/csvExampleData";

export default {
  name: "BulkUploadCSV",
  components: {
    AgGridVue,
    ProcessLoader,
    FieldSettings,
  },
  data: () => ({
    file: null,
    uploadType: 0,
    handler: null,
    exampleData: null,
    rowData: null,
    columnDefs: null,
    gridApi: null,
    gridOptions: null,
    defaultColDef: {
      resizable: true,
    },
    loaded: 0,
    show: false,
    filecopy: null,
    excludePayment: false,
    showPrompt: false,
    log: null,
    lastAddedIndex: -1,
    search: "",
    useIndiviualField: false,
  }),
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.updateColumnNames();
    this.updateUseIndiviualField();
  },
  beforeMount() {
    this.gridOptions = { defaultToolPanel: "", maintainColumnOrder: true };
    this.columnDefs = [];
    this.rowData = [];
  },
  computed: {
    getUploadType() {
      switch (this.uploadType) {
        case 0:
          return "Upload VoIP services";
        case 1:
          return "Upload Misc Transactions";
        case 2:
          return "Upload New Mobiles";
        case 3:
          return "Upload New Customers";
        case 4:
          return "Upload Disconnect Services";
        case 5:
          return "Upload NBN Services";
        case 6:
          return "Upload MNF Agents";
        case 7:
          return "Upload Inbound Services";
        default:
          return "Upload VoIP services";
      }
    },
  },
  watch: {
    search(val) {
      this.gridApi.setQuickFilter(val);
    },
    uploadType(val) {
      this.useIndiviualField = false;
      this.updateColumnNames();
      return val;
    },
    columnDefs() {
      return this.columnDefs;
    },
    useIndiviualField() {
      this.rowData = [];
      this.file = null;
      this.filecopy = null;
      return this.useIndiviualField;
    },
  },
  methods: {
    onGridReady(args) {
      this.gridApi = args.api;
    },
    readCSV(item) {
      if (item) {
        try {
          var vm = this;
          vm.filecopy = item;
          if (!vm.file.name.toLowerCase().includes("csv")) {
            alert("Please upload CSV File.");
            return;
          }
          vm.rowData = [];
          this.updateColumnNames();
          this.updateUseIndiviualField();

          new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.readAsText(item);
            reader.onload = (e) => {
              parse(
                reader.result,
                {
                  columns: true,
                  skip_empty_lines: true,
                  relax_column_count: true,
                },
                function (err, output) {
                  if (err) {
                    vm.errorMessage = err;
                    reject(err);
                  } else {
                    vm.rowData = output.filter((x) => {
                      var filtered = Object.keys(x).filter(
                        (key) => x[key] != ""
                      );
                      return filtered.length > 0 ? x : "";
                    });
                    if (vm.rowData.length) {
                      vm.$refs.config.fileHeaders = Object.keys(
                        vm.rowData[0]
                      ).map((e) => {
                        return {
                          headerName: e,
                          field: e,
                        };
                      });
                      vm.show = true;
                    }
                    vm.gridApi.sizeColumnsToFit();
                    resolve(output);
                  }
                }
              );
            };
          });
        } catch (error) {
          throw error;
        }
      }
    },
    onUpload() {
      let vm = this;
      let isBulk = vm.rowData.length >= 200;

      if (!isBulk) {
        return this.upload();
      }

      let formData = new FormData();
      if (vm.file != null || vm.filecopy != null) {
        formData.append("file", vm.file || vm.filecopy);
        this.bulkUpload(formData)
          .then((data) => {
            this.rowData = data.data;
            this.$forceUpdate();
          })
          .catch(() => {});
      }
    },
    formatDate(str) {
      let date = "";
      if (str || str !== "NULL") {
        let splitParts = str.split("/");
        date = `${splitParts[2]}-${splitParts[1]}-${splitParts[1].length}`;
      }
      return new Date(date) == "Invalid date" ? "" : date;
    },
    async upload() {
      let vm = this;
      if (!vm.rowData.length) {
        alert("Please select a file to upload");
        return;
      }
      let rowData = [];
      vm.$refs.loader.show = true;
      await Promise.all(
        vm.rowData.map((data, i) => {
          if (data.csn && data.csn.length > 8) data.mobileNumberMsn = data.csn;
          data.excludePayment = vm.excludePayment;
          data.contractLength = +data.contractLength;
          data.success = false;
          data.reason = "";
          return new Promise((resolve, reject) => {
            let response = HTTP.post("BulkUpload/" + vm.handler, data);
            response
              .then((res) => {
                if (Object.keys(res.data).includes("data")) {
                  if (!res.data.data || res.data.data.length == 0) {
                    data.reason = res.data.message || "Ok";
                    data.success = res.data.success;
                    rowData.push(data);
                    resolve(data);
                    return;
                  }
                }

                let returnData = { ...data, ...res.data[0] };
                returnData.success = res.data.success;
                returnData.reason = res.data[0]?.reason || res.data.message;

                switch (vm.uploadType) {
                  case 0:
                    returnData.success = res.data[0].success;
                    returnData.reason =
                      res.data.message ||
                      res.data[0]?.reason ||
                      res.data.message;
                    break;
                  case 1:
                    returnData = { ...data, ...res.data.data[0].return };
                    if (!returnData.isError) {
                      returnData.success = true;
                      returnData.reason = "Ok";
                    } else {
                      returnData.success = false;
                      returnData.reason = res.data.message || res.data.reason;
                    }
                    break;
                  case 2:
                    returnData = { ...data, ...res.data[0] };
                    break;
                  case 5:
                    returnData = { ...data, ...res.data[0] };
                    break;
                  case 7:
                    returnData = { ...data, ...res.data[0] };
                    break;
                  default:
                    if (returnData.success) {
                      returnData.success = true;
                    } else {
                      returnData.success = false;
                    }
                    break;
                }
                rowData.push(returnData);
                ++vm.lastAddedIndex;
                vm.closeModal();
                resolve(data);
              })
              .catch((err) => {
                let returnData = {
                  ...data,
                  success: false,
                  reason: err?.response?.data || err.message,
                };
                rowData.splice(vm.lastAddedIndex, 1);
                rowData.push(returnData);
                ++vm.lastAddedIndex;

                vm.closeModal();
                reject(rowData);
              })
              .finally(() => {
                vm.closeModal();
                ++this.loaded;
                if (this.loaded == this.rowData.length) {
                  vm.$refs.loader.show = false;
                }
              });
          });
        })
      )
        .then(() => {
          vm.$refs.loader.show = false;
          vm.rowData = rowData;
          this.gridApi.setRowData(vm.rowData);
          vm.uploadLogs(rowData);
        })
        .catch((err) => {
          vm.rowData = err;
          this.gridApi.setRowData(vm.rowData);
          vm.uploadLogs(vm.rowData);
          vm.$refs.loader.show = false;
        })
        .finally(() => {
          vm.$refs.loader.show = false;
          this.loaded = 0;
        });
    },
    bulkUpload(formData) {
      let vm = this;
      return new Promise((resolve, reject) => {
        let response = HTTP.post("BulkUpload/form/" + vm.handler, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        vm.showPrompt = true;
        // vm.file = null;
        // vm.filecopy = null;
        vm.gridApi.setRowData([]);
        response
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    healthCheck() {
      return new Promise((resolve, reject) => {
        let response = HTTP.get("BulkUpload/HealthCheck");
        response
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    csvExport() {
      var arrData = this.rowData;
      var rows = [];
      rows.push(this.columnDefs.map((item) => item.headerName));
      rows = rows.concat(this.convertJson(arrData));
      let csvContent =
        "data:text/csv;charset=utf-8," +
        rows.map((e) => e.join(",")).join("\n");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "uploadResult.csv");
      link.click();
    },
    downloadCsvExample() {
      this.updateColumnNames();
      this.updateUseIndiviualField();
      var rows = [];
      // var headers =
      //   this.uploadType == 0 ? voipServicesExampleHeader : this.columnDefs;

      if (this.uploadType == 0) {
        var headers = voipServicesExampleHeader;
      } else if (this.uploadType == 2) {
        var headers = newMobilesExampleHeaders;
      } else if (this.uploadType == 5) {
        var headers = nbnExampleHeaders;
      } else {
        var headers = this.columnDefs;
      }

      rows.push(headers.slice(0, headers.length - 2).map((item) => item.field));
      rows = rows.concat(this.exampleData);
      let csvContent =
        "data:text/csv;charset=utf-8," +
        rows.map((e) => e.join(",")).join("\n");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", this.handler + "ExampleData.csv");
      link.click();
    },
    convertJson(arrData) {
      if (
        this.handler == "bulkUploadVoipServices" ||
        this.handler == "bulkUploadMobileServices"
      ) {
        return arrData.map((item) => Object.values(new VoipService(item)));
      } else if (this.handler == "bulkUploadTransactions") {
        return arrData.map((item) => Object.values(new Transaction(item)));
      } else if (this.handler == "bulkUploadDisconnectServices") {
        return arrData.map((item) =>
          Object.values(new DisconnectService(item))
        );
      } else if (this.handler == "bulkUploadCustomers") {
        let data = arrData.map((item) => Object.values(new Customer(item)));

        return data;
      }
    },
    createObjectWithHeader(arrData) {
      if (
        this.handler == "bulkUploadVoipServices" ||
        this.handler == "bulkUploadMobileServices"
      ) {
        return arrData.map((item) => createVoipServiceWithHeaderName(item));
      } else if (this.handler == "bulkUploadTransactions") {
        return arrData.map((item) => createTransactionWithHeaderName(item));
      } else if (this.handler == "bulkUploadDisconnectServices") {
        return arrData.map((item) =>
          createDisconnectServiceWithHeaderName(item)
        );
      }
    },
    reset() {
      this.rowData = [];
      this.columnDefs = [];
      this.exampleData = null;
      this.formData = null;
      this.file = null;
    },
    updateColumnNames() {
      switch (this.uploadType) {
        case 0:
          this.$refs.config.setHeader(voipServicesHeaders);
          this.columnDefs = voipServicesHeaders;
          this.handler = "bulkUploadVoipServices";
          this.exampleData = voipServicesExample;
          break;
        case 1:
          this.$refs.config.setHeader(transactionsHeaders);
          this.columnDefs = transactionsHeaders;
          this.handler = "bulkUploadTransactions";
          this.exampleData = transactionsExample;
          break;
        case 2:
          this.$refs.config.setHeader(newMobilesHeaders);
          this.columnDefs = newMobilesHeaders;
          this.handler = "bulkUploadMobileServices";
          this.exampleData = newMobilesExample;
          break;
        case 3:
          this.$refs.config.setHeader(customerHeaders);
          this.columnDefs = customerHeaders;
          this.handler = "bulkUploadCustomers";
          this.exampleData = customerExample;
          break;
        case 4:
          this.$refs.config.setHeader(disconnectHeaders);
          this.columnDefs = disconnectHeaders;
          this.handler = "bulkUploadDisconnectServices";
          this.exampleData = disconnectExample;
          break;
        case 5:
          this.$refs.config.setHeader(nbnHeaders);
          this.columnDefs = nbnHeaders;
          this.handler = "bulkUploadNBNServices";
          this.exampleData = nbnExample;
          break;
        case 6:
          this.$refs.config.setHeader(mnfHeaders);
          this.columnDefs = mnfHeaders;
          this.handler = "BulkUploadInterestedAgents/44";
          this.exampleData = mnfAgentExampleData;
          break;
        case 7:
          this.$refs.config.setHeader(inboundHeaders);
          this.columnDefs = inboundHeaders;
          this.handler = "bulkUploadInboundServices";
          this.exampleData = inboundExample;
          break;
        default:
          this.$refs.config.setHeader(voipServicesHeaders);
          this.columnDefs = voipServicesHeaders;
          this.handler = "bulkUploadVoipServices";
          this.exampleData = voipServicesExample;
          break;
      }
    },

    closeModal() {
      let vm = this;
      if (vm.$refs.loader.getPendingCount === 0) {
        vm.$refs.loader.show = false;
        vm.loaded = 0;
      }
    },

    close() {
      let vm = this;
      vm.reset();
      vm.file = null;
      vm.show = false;
    },
    updateHeader(header, isUpdate = true) {
      this.updateUseIndiviualField();
      try {
        this.show = false;
        // this.file = null;
        let updatedRow = [];
        if (isUpdate) {
          updatedRow = this.rowData.map((el) => {
            let parsedItem = {};
            for (const col of this.columnDefs) {
              let updated = header.find((i) => i.headerName == col.headerName);
              parsedItem[col.field] = el[updated.field];
            }
            return { ...parsedItem, success: null, reason: null };
          });
          this.rowData = updatedRow;
          this.gridApi.setRowData(updatedRow);
          if (this.rowData.length >= 200) {
            this.showPrompt = true;
          }
        }
        this.$refs.config.reset();
      } catch (error) {
        throw error;
      }
    },
    uploadLogs(rowData) {
      var rows = [];
      rows.push(this.columnDefs.map((item) => item.headerName));
      let arrData = rowData.map((row) => {
        return this.columnDefs
          .map((item) => item.field)
          .map((field) => {
            return row[field];
          });
      });
      rows = rows.concat(arrData);
      let csvContent = rows
        .map((e) => {
          if (e) return e.join(",");
        })
        .join("\n");
      const data = encodeURI(csvContent);
      var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      let _file = new File([blob], `${this.handler}.csv`, {
        type: "text/csv;charset=utf-8;",
        lastModified: new Date().getTime(),
      });
      let container = new DataTransfer();
      container.items.add(_file);
      document.getElementById("logFile").files = container.files;
      let logFile = document.getElementById("logFile").files[0];
      let formData = new FormData();
      formData.append("file", logFile);
      formData.append("type", this.handler.replace("/", "_"));
      return new Promise((resolve, reject) => {
        let response = HTTP.post("BulkUpload/BulkUploadLogs", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        response
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    onExportCsv() {
      var params = {
        fileName: this.handler,
      };

      this.gridApi.exportDataAsCsv(params);
    },
    updateUseIndiviualField() {
      this.updateColumnNames();

      let addressFields = [
        { headerName: "StreetNumber", field: "streetNumber", sortable: true },
        { headerName: "StreetName", field: "streetName", sortable: true },
        { headerName: "StreetType", field: "streetType", sortable: true },
        { headerName: "Suburb", field: "suburb", sortable: true },
        { headerName: "State", field: "state", sortable: true },
        { headerName: "Postcode", field: "postcode", sortable: true },
      ];
      if (this.uploadType == 3) {
        this.columnDefs = [];
        this.gridApi.setColumnDefs(this.columnDefs);
        if (this.useIndiviualField) {
          var newCols = [...customerHeaders];
          newCols.splice(4, 0, ...addressFields);

          newCols = newCols.filter((e) => e.headerName != "Address*");
          this.columnDefs = [...newCols];
          this.exampleData = customer2Example;
        } else {
          this.columnDefs = [...customerHeaders];
          this.exampleData = customerExample;
        }

        this.$refs.config.setHeader(this.columnDefs);
        this.gridApi.setColumnDefs(this.columnDefs);
      }
    },
  },
};
</script>

<style scoped>
.uploadbtns button {
  font-weight: 600;
}
.v-tab {
  text-transform: capitalize;
}
.v-tab i {
  opacity: 0;
  position: absolute;
  left: 0;
  right: 70px;
  top: 7px;
}
.v-tab.v-tab--active i {
  opacity: 1 !important;
}

.custom-fab {
  position: fixed !important;
  right: 10px;
  bottom: 50px;
}

.ag-font-style {
  user-select: initial;
  -moz-user-select: text;
  -ms-user-select: text;
  -webkit-user-select: text;
}
</style>
